const API_BASE = ''

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      'content-type': 'application/json',
      ...(init?.headers || {}),
    },
  })
  if (!res.ok) {
    const text = await res.text().catch(() => 'error')
    throw new Error(text || `HTTP ${res.status}`)
  }
  return res.json()
}

export async function createExperiment(payload: { case_label: string; scenario_text?: string; turnstile_token?: string }) {
  return api<CreateExperimentResponse>('/api/experiments', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export interface CreateExperimentResponse {
  experiment_id: string
  private_control_url: string
  owner_secret: string
}

export async function getExperiment(id: string, secret: string) {
  return api<any>(`/api/experiments/${id}?k=${encodeURIComponent(secret)}`)
}

export async function addFragment(experimentId: string, secret: string, fragment: { text: string; kind: string }) {
  return api<any>('/api/experiments/' + experimentId + '/fragments', {
    method: 'POST',
    headers: { 'x-owner-secret': secret },
    body: JSON.stringify(fragment),
  })
}

export async function addInterpretation(experimentId: string, secret: string, fragmentId: string, interp: { lens: string; text: string }) {
  return api<any>(`/api/experiments/${experimentId}/fragments/${fragmentId}/interpretations`, {
    method: 'POST',
    headers: { 'x-owner-secret': secret },
    body: JSON.stringify(interp),
  })
}

export async function addHold(experimentId: string, secret: string, hold: { targetType: string; targetId?: string; note?: string }) {
  return api<any>(`/api/experiments/${experimentId}/holds`, {
    method: 'POST',
    headers: { 'x-owner-secret': secret },
    body: JSON.stringify(hold),
  })
}

export async function logProbe(experimentId: string, secret: string, probe: any) {
  return api<any>(`/api/experiments/${experimentId}/probes`, {
    method: 'POST',
    headers: { 'x-owner-secret': secret },
    body: JSON.stringify(probe),
  })
}

export async function castBudget(experimentId: string, secret: string, payload: any) {
  return api<any>(`/api/experiments/${experimentId}/budget`, {
    method: 'POST',
    headers: { 'x-owner-secret': secret },
    body: JSON.stringify(payload),
  })
}

export async function exportExperiment(experimentId: string, secret: string) {
  return api<any>(`/api/experiments/${experimentId}/export?k=${encodeURIComponent(secret)}`)
}

export async function deleteExperiment(experimentId: string, secret: string) {
  return api<any>(`/api/experiments/${experimentId}/delete`, {
    method: 'POST',
    headers: { 'x-owner-secret': secret },
  })
}

export async function getSimilar(experimentId: string, secret?: string) {
  const q = secret ? `?k=${encodeURIComponent(secret)}` : ''
  return api<any>(`/api/experiments/${experimentId}/similar${q}`)
}

export async function verifyTurnstileForStart(token: string) {
  // In real flow the token is sent on createExperiment. This is a helper if separate.
  return true
}
